import initPersistor from './stores/persistor';
import logger from './debug';
import { Page } from './types';

const styleElementId = 'mdat-style';

const attributes: ReadonlyArray<{ name: string; color: string }> = [
  { name: 'data-mdat', color: 'rgb(176, 196, 222)' },
  { name: 'data-mdat-module', color: 'rgb(144, 238, 144)' },
  { name: 'data-mdat-item-id', color: 'rgb(224, 255, 255)' },
  { name: 'data-mdat-element-id', color: 'rgb(255, 182, 193)' },
];
const pageEventAttribute = 'data-mdat-current-page';

const getAttributeSelector = (name: string) => `*[${name}]`;
const pageTagSelector = `body[${pageEventAttribute}]`;

const getTagStyle = (selector: string, attribute: string, color: string, position = 'after', zIndex = 0, side = 'left') => `
${selector}:${position} {
  content: attr(${attribute});
  background-color: ${color};
  color: rgb(0, 0, 0);
  position: absolute;
  font-size: xx-small;
  border: 1px solid rgb(169, 169, 169);
  border-radius: 4px;
  ${side}: 0;
  top: 0;
  padding: 2px;
  line-height: initial;
  z-index: ${100_000 + zIndex};
}
${selector}:hover:${position} {
  z-index: ${200_000 + zIndex}
}`;

const getAttributeStyles = () =>
  attributes.map((attr, index) => getTagStyle(getAttributeSelector(attr.name), attr.name, attr.color, 'after', index)).join('\n');
const getPageEventStyle = () => getTagStyle(pageTagSelector, pageEventAttribute, 'rgb(250, 250, 210)', 'before', -1, 'right');
const getAnchorsStyle = () => `${attributes.map(attr => getAttributeSelector(attr.name)).join(', ')} {
  position: relative !important;
}`;

const createStyleElement = () => {
  const element = document.createElement('style');
  element.id = styleElementId;
  element.textContent = `${getAnchorsStyle()}
${getAttributeStyles()}
${getPageEventStyle()}
`;

  return element;
};

const enableVisualization = () => {
  if (!document.getElementById(styleElementId)) {
    const styleElement = createStyleElement();
    document.head.appendChild(styleElement);
    logger.debug('Visualization style element added');
  }
};

const disableVisualization = () => {
  const styleElement = document.getElementById(styleElementId);
  if (styleElement) {
    styleElement.parentNode?.removeChild(styleElement);
    logger.debug('Visualization style element removed');
  }
};

declare global {
  interface Window {
    /**
     * Enable or disable visualization of the mdat tags
     */
    mdatShow: boolean;
  }
}

const visualizationPersister = initPersistor<boolean>({ ttlSeconds: 365 * 24 * 60 * 60, storageKey: 'visualize' });

if (visualizationPersister.get(false)) {
  enableVisualization();
}

Object.defineProperty(window, 'mdatShow', {
  get: function () {
    return visualizationPersister.get(false);
  },
  set: function (newValue: boolean) {
    visualizationPersister.set(Boolean(newValue));
    if (newValue) {
      enableVisualization();
    } else {
      disableVisualization();
    }
  },
});

export const setPageName = (page: Page) => {
  const name = [page.category, page.subCategory, page.type, page.id].filter(e => Boolean(e)).join('\\');
  document.body.setAttribute(pageEventAttribute, name);
};
